import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r?.data?.session_token) setStoredToken(r.data.session_token);
        setUser(r.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center login-gradient">
      <div className="text-center">
        <div className="overline mb-3">authenticating</div>
        <div className="heading text-2xl text-zinc-100">Setting up your workspace…</div>
      </div>
    </div>
  );
}
